export const ROUTES = {
  splash: '/',
  login: '/login',
  kyc: '/kyc',
  home: '/home',
  loanApply: '/loan/apply',
  loanConfirm: '/loan/confirm',
  loanSuccess: '/loan/success',
  loansList: '/loans',
  score: '/score',
  repay: '/repay',
  profile: '/profile',
} as const;

export type Route = (typeof ROUTES)[keyof typeof ROUTES];
